import { render, staticRenderFns } from "./starterPoll.vue?vue&type=template&id=761a3fda&scoped=true&"
import script from "./starterPoll.vue?vue&type=script&lang=js&"
export * from "./starterPoll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761a3fda",
  null
  
)

export default component.exports